import sample from 'lodash.sample'
import React from 'react'
import {Flex, Skeleton, Stack} from '@chakra-ui/react'

const NAME_SIZES = [20, 24, 32, 40, 48]
const CITY_SIZES = [16, 24, 32]

export function UserCardSkeleton() {
  return (
    <Flex bg="white" borderRadius="md" boxShadow="sm" overflow="hidden" p={3}>
      <Skeleton borderRadius="md" boxShadow="sm" h={160} w={160} />
      <Flex direction="column" flex={1} justify="space-between" ml={8}>
        <Stack>
          <Skeleton h={6} w={sample(NAME_SIZES)} />
          <Skeleton h={4} w={sample(CITY_SIZES)} />
        </Stack>

        <Skeleton h={8} />
      </Flex>
    </Flex>
  )
}
